import {
  AutodeskIntegrationIcon,
  ProcoreIntegrationIcon,
} from "@components/common/icons";
import { IntegrationInfo } from "@custom-types/integrations-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** Information of each integration */
export const INTEGRATION_INFO: Record<
  FaroCoreApiTypes.IntegrationId,
  IntegrationInfo
> = {
  autodesk: {
    displayName: "Autodesk",
    description:
      "Create and view RFIs and Issues directly within the platform.",
    icon: AutodeskIntegrationIcon,
  },
  procore: {
    displayName: "Procore",
    description:
      "Create and view RFIs and Observations directly within the platform.",
    icon: ProcoreIntegrationIcon,
  },
};
